import HtmlElement from './HtmlElement';
import {Settings} from "../Settings";
import {$window} from "../Constants";
import Header from "./Header";

/**
 * CtaSwap
 *
 * @return Array
 */
const CtaSwap = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		CTA_SWAP: '.cta-swap',
		SLIDE: '.cta-swap-slide',
		FLAG: '.cta-swap-flag',
		CLOSE: '.cta-swap-close'
	};

	/**
	 * CtaSwap
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class CtaSwap extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			this.slides = this.getSlides();
			this.swapped = false;
			this.interval = null;
			this.collapsed = false;
			this.timeout = 4500;
			this.isMouseOver = false;
			this.activeSlideIndex = 0;
			this.adjustHeight();
			$('body').addClass('has-cta');

			document.body.style.setProperty('--cta-swap-height', `3.75rem`);

			if (Settings.bannerAdjust && $window.width() < 1024) {
				$('.banner').css('margin-top', Header.getHeight() + $('.cta-swap-flag').outerHeight());
			} else {
				$('.banner').css('margin-top', Header.getHeight());
			}

			if ($(window).width() >= 1024) {
				this.checkCollapsed();

				$(window).on('scroll', () => {
					this.checkCollapsed();
				});
			} else {
				this.$element.find(Selector.FLAG).on('click', () => {
					this.$element.closest('.cta-swap-section').addClass('cta-visible');
					// this.startSwap();
				});

				this.$element.find(Selector.CLOSE).on('click', () => {
					this.$element.closest('.cta-swap-section').removeClass('cta-visible');
					// this.stopSwap();
				});

				$('#header').css('top', this.$element.find(Selector.FLAG).outerHeight());
			}

			this.$element.find('.cta-swap-flag-slide').each((i, slide) => {
				const $marquee = $(slide).find('.cta-swap-marquee');
				let width = 0;

				$marquee.find('p').each((i, p) => {
					width = width + $(p).outerWidth(true);
				});

				$marquee.css('width', width);
			});

			this.startSwap();
			this.bindHandlers();
		}

		checkCollapsed() {
			const $section = this.$element.closest('.cta-swap-section');
			const offset = $section.offset().top - $('#header').outerHeight();
			const sectionHeight = $section.outerHeight();
			const threshold = offset + sectionHeight;

			if (!this.collapsed) {
				if (threshold < $(window).scrollTop()) {
					this.$element.closest('.cta-swap-section').addClass('scrolled');
					this.$element.find('.cta-swap-slides').css({
						left: $('window').width() / 2 - this.$element.find('.cta-swap-slide-box').outerWidth() / 2
					});
					this.hide();
				}
			} else {
				if (threshold >= $(window).scrollTop()) {
					this.$element.closest('.cta-swap-section').removeClass('scrolled');
					this.$element.find('.cta-swap-slides').css({
						top: null,
						lef: null
					});
					this.show();
				}
			}
		}

		show() {
			this.$element.closest('.cta-swap-section').addClass('cta-visible');
			this.$element.closest('.cta-swap-section').removeClass('cta-collapsed');
			this.collapsed = false;
		}

		hide() {
			this.$element.closest('.cta-swap-section').removeClass('cta-visible');
			this.$element.closest('.cta-swap-section').addClass('cta-collapsed');
			this.collapsed = true;
		}

		bindHandlers() {
			this.$element.find('.cta-swap-slides').on('mouseenter', () => {
				this.isMouseOver = true;
			});

			this.$element.find('.cta-swap-slides').on('mouseleave', () => {
				this.isMouseOver = false;
			});

			this.$element.find('.cta-swap-flag').on('click', () => {
				this.show();
			});
		}

		getSlides() {
			const slides = [];

			this.$element.find(Selector.SLIDE).each((i, el) => {
				slides.push($(el));
			});

			return slides;
		}

		startSwap() {
			this.interval = setInterval(() => {
				this.swap();
			}, this.timeout);
		}

		stopSwap() {
			clearInterval(this.interval);
		}

		swap() {
			const isFocused = this.$element.find('input, select').is(':focus');

			if (isFocused || this.isMouseOver) {
				return
			}

			this.$element.closest('.cta-swap-section').toggleClass('swap', !this.swapped);
			this.swapped = !this.swapped;
			this.activeSlideIndex = this.swapped ? 1 : 0;
		}

		getSlideByIndex(index) {
			return this.slides[index];
		}

		getMaxHeightOfSlides() {
			const heights = [];

			this.slides.forEach((slide) => {
				heights.push(slide.outerHeight());
			});

			return Math.max.apply(null, heights);
		}

		adjustHeight() {
			this.$element.find('.cta-swap-slides').css('height', this.getMaxHeightOfSlides());

			if ($(window).width() >= 1024) {
				this.$element.css('height', this.getMaxHeightOfSlides());
			}
		}
	}

	return CtaSwap._getElements(Selector.CTA_SWAP, CtaSwap);
})();

export default CtaSwap;
